// extracted by mini-css-extract-plugin
module.exports = {"menuWrapper":"navigationSideMenu_menuWrapper__1x5Bl","logo":"navigationSideMenu_logo__EkN1C","logoWrapper":"navigationSideMenu_logoWrapper__3g6yQ"};